//TODO move the constants 'read/edit/send' to enum
// enum Mode {
//     READ = 'ready',
//     EDIT = 'edit',
//     SENDING = 'sending',
// }
/**
 * Controller for MYSA IM outbound Opportunity Log admin page
 */
var MysaImOutboundViewController = (function () {
    function MysaImOutboundViewController(env, socket, $scope, baseDialog, notify, $state) {
        var _this = this;
        this.env = env;
        this.socket = socket;
        this.$scope = $scope;
        this.baseDialog = baseDialog;
        this.notify = notify;
        this.$state = $state;
        this.scopePrefix = 'admin.mysa-in-outbond';
        this.scopeOutboundSend = this.scopePrefix + ".send";
        this.loaded = { outbound: false, opp: false, ready: false };
        this.serverError = undefined;
        this.defects = { outbound: undefined, total: 0 };
        this.filter = { defectOUT: '', errorOnly: false };
        this.oppLog = { log: undefined, notfound: false, editMode: false, searching: { in: {}, out: {}, opp: false }, opp: '', oppty: '', in: [], out: [] };
        // Listener for the outbound defects to arrive
        this.socket.forward('mysa.mysa-im-outbound-defects', this.$scope);
        this.$scope.$on('socket:mysa.mysa-im-outbound-defects', function (event, payload) {
            if (angular.isDefined(payload.error)) {
                // this.serverError = payload.error;
                // Flash the error and go back to admin view
                _this.notify.error(payload.error);
                $state.go('admin.main');
            }
            else {
                _this.defects[payload.type] = payload.data;
                _this.loaded[payload.type] = true;
                _this.isReady();
            }
        });
        // Listener for the opp log retrieval to arrive
        this.socket.forward('mysa.mysa-im-outbound-opp-log', this.$scope);
        this.$scope.$on('socket:mysa.mysa-im-outbound-opp-log', function (event, payload) {
            // - console.info(payload);
            _this.oppLog.searching = { out: {}, opp: false }; // Reset search button
            if (angular.isDefined(payload.error)) {
                // this.serverError = payload.error;
                _this.notify.error(payload.error);
            }
            else if (!angular.isDefined(payload.data)) {
                _this.oppLog.notfound = true;
            }
            else {
                _this.oppLog.out = payload.data.logEntriesOutBound;
                if (!payload.data._id) {
                }
                else {
                    _this.oppLog.oppty = payload.data._id.substr(payload.data._id.indexOf('LOG-') + 4);
                }
                _this.loaded.opp = true;
            }
        });
        // SEND
        this.socket.forward(this.scopeOutboundSend, this.$scope);
        this.$scope.$on("socket:" + this.scopeOutboundSend, function (event, respData) {
            // - console.log('on scopeOutboundSend - im - outbound - opp - log');
            if (respData && respData.error) {
                _this.notify.error("Unable to send outbound: " + respData.error);
            }
            else {
                // - console.log(this.baseDialog.getData());
                var dlgData = _this.baseDialog.getData();
                dlgData.log = dlgData;
                dlgData.mode = 'read';
                dlgData.trigger = _this.env.user.email;
                dlgData.success = respData.success;
                dlgData.message = respData.msg;
                _this.notify.success("Outboud is sent. Status: " + (respData && respData.status));
            }
        });
    }
    /**
     * Function to view the details of the outbound log details in a pop-up
     * @param entry - Object - the entire log details
     * @param inout - String - whether Outbound log
     */
    MysaImOutboundViewController.prototype.viewLog = function (entry, isLast) {
        // - console.log(`viewlog: [${entry}]`);
        var _this = this;
        var d = this.generateData(entry, isLast);
        var requestBodyOrg = d.requestBody;
        //const scope: any = this;
        //Object containing details for the pop - up
        var items = {
            data: d,
            isEditMode: function () {
                return items.data.mode === 'edit';
            },
            isSendMode: function () {
                return items.data.mode === 'send';
            },
            onClose: function () {
                _this.baseDialog.hide();
            },
            onEdit: function () {
                // - console.log(`onEdit - items.data.mode: ${items.data.mode}`);
                if (items.data.mode !== 'read') {
                    items.data.mode = 'read';
                    items.data.requestBody = requestBodyOrg;
                }
                else {
                    items.data.mode = 'edit';
                }
            },
            onSend: function (outboundText) {
                // - console.log(`onSend: ${outboundText}`);
                items.data.mode = 'send';
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        function: 'outboundToMysaIm',
                        opp: items.data.opp,
                        outboundBody: outboundText,
                        script: MysaImOutboundViewController.URL_ADMIN_MYSA_IM_OUTBOUND,
                        user: _this.env.user
                    }
                });
            }
        };
        //Display pop - up
        this.baseDialog.show(event, 'mysa-im-outbound-dlg.html', items)
            .then(function () {
            // - console.log('dlg:: hidden');
            _this.requestOutbound();
            _this.retrieveOutLog(d.opp);
        }).catch(function (e) {
            // - console.log(e);
            _this.requestOutbound();
            _this.retrieveOutLog(d.opp);
        });
    };
    /**
     * Function fired when initially outbound data is received.  Only if both are loaded, will the
     * page detail appear
     */
    MysaImOutboundViewController.prototype.isReady = function () {
        if (this.loaded.outbound) {
            this.defects.total = this.defects.outbound.length;
            this.defects.totalError = this.defects.outbound.filter(function (opp) { return !opp.value.success; }).length;
            this.loaded.ready = true;
        }
    };
    /**
     * Function to collect an opportunity's log document from cloudant - could be called via the search button, or
     * when selecting from the defect list
     * @param oppNum - String - the opportunity number
     * @param index - Number - the index number of the defect selected by the user
     */
    MysaImOutboundViewController.prototype.retrieveOutLog = function (oppNum, index) {
        // - console.log('retrieveOutLog index=' + index);
        var io = 'out';
        // Set search flag accordingly
        if (index > -1) {
            this.oppLog.searching[io][index] = true;
        }
        else {
            this.oppLog.searching.opp = true;
        }
        this.oppLog.notfound = false; // reset
        // Make call to server
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getLogByOpp',
                opp: oppNum,
                script: MysaImOutboundViewController.URL_ADMIN_MYSA_IM_OUTBOUND,
                user: this.env.user
            }
        });
    };
    MysaImOutboundViewController.prototype.getDate = function (date) {
        return new Date(date);
    };
    MysaImOutboundViewController.prototype.getStatus = function (log) {
        return log && log.logObject && log.logObject.incentiveStatus || 'no status defined';
    };
    MysaImOutboundViewController.prototype.getTitle = function (log) {
        return log.message.substr(0, 100) + "... Click to display request details";
    };
    MysaImOutboundViewController.prototype.$onInit = function () {
        this.requestOutbound();
    };
    MysaImOutboundViewController.prototype.generateData = function (ent, isLast) {
        var entry = ent || {};
        // - console.log(entry.logObject);
        return {
            isLast: (isLast === true || isLast === false) ? isLast : true,
            message: (entry.message.info || entry.message),
            mode: 'read',
            module: entry.module,
            opp: this.oppLog.oppty,
            requestBody: entry.requestBody,
            success: entry.success,
            time: this.getDate(entry.timestamp),
            trigger: entry.trigger
        };
    };
    /**
     * Make calls to get the outbound defects
     */
    // tslint:disable-next-line: typedef
    MysaImOutboundViewController.prototype.requestOutbound = function () {
        // - console.log('requestOutbound');
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getMysaImOutbounds',
                script: MysaImOutboundViewController.URL_ADMIN_MYSA_IM_OUTBOUND,
                user: this.env.user
            }
        });
    };
    MysaImOutboundViewController.$inject = ['env', 'socket', '$scope', 'baseDialog', 'notify', '$state'];
    MysaImOutboundViewController.URL_ADMIN_MYSA_IM_OUTBOUND = '/admin/mysa-im-outbound/mysa-im-outbound';
    return MysaImOutboundViewController;
}());
// tslint:disable-next-line: max-classes-per-file
var MysaImOutboundViewComponent = (function () {
    function MysaImOutboundViewComponent() {
        this.templateUrl = 'mysa-im-outbound-view.html';
        this.controllerAs = 'vm';
        this.controller = MysaImOutboundViewController;
    }
    return MysaImOutboundViewComponent;
}());
angular
    .module('application')
    .component('viewMysaImOutboundSection', new MysaImOutboundViewComponent());

//# sourceMappingURL=mysa-im-outbound.view.component.js.map
